import * as actions from './actions';
import getters from './getters';
import mutations from './mutations';

/* ========================== STATE ============================ */
const state = {
  optimizer_running: false,
  optimizer_auto_trigger: true,
  optimizer_result: {
    finishDatesTasks: {},
    finishDatesCommmitments: {},
  },
  optimizer_state: 'not_triggered',
  optimizer_response_time: -1,
  optimizer_user_error: '',
  masked_event_ids: [],
  optimizer_algorithm: 'goalpilot_action_plan_v3',
  optimizer_planning_horizon: 28,
  optimizer_manual_dayplan: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
